import React, { useRef, useEffect, useState } from 'react';
import AboutBanner from '../../components/AboutBanner';
import HeaderSection from '../../components/HeaderSection';
import Navbar from '../../components/Navbar';
import AboutPersonalized from '../../components/AboutPersonalized';
import Team from '../../components/Team';
import AboutNutritionSection from '../../components/AboutNutritionSection';
import Footer from '../../components/Footer';
import Founder from '../../components/Founder';
import AboutJourney from '../../components/AboutJourney';
import AboutBenefit from '../../components/AboutBenefit';
import Timeline from '../../components/TimeLine';
import { getSeoByUrl } from '../../api/api';

const AboutUS = () => {
  const appointmentRef = useRef(null);
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(true);

  const scrollToAppointment = () => {
    if (appointmentRef.current) {
      appointmentRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("about-us");
        
        if (response.success && response.data) {
          setSeoData(response.data);
          updateMetaTags(response.data);
          console.log("About page SEO loaded:", response.data.metaTitle);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSeoData();
  }, []);

  const updateMetaTags = (data) => {
    if (data.metaTitle) document.title = data.metaTitle;
    
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    if (data.metaDescription) metaDesc.setAttribute('content', data.metaDescription);
    
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    if (data.robotsTxt) robotsMeta.setAttribute('content', data.robotsTxt);
    
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    if (data.canonicalUrl) canonicalLink.setAttribute('href', data.canonicalUrl);
    
    if (data.schemaMarkup) {
      let existingScript = document.querySelector('#schema-markup');
      if (existingScript) existingScript.remove();
      
      const script = document.createElement('script');
      script.id = 'schema-markup';
      script.type = 'application/ld+json';
      script.textContent = data.schemaMarkup;
      document.head.appendChild(script);
    }
  };

  return (
    <div>
      <AboutBanner />
      <Timeline />
      <AboutPersonalized />
      <Team />
      <AboutNutritionSection />
      <AboutJourney />
      <AboutBenefit />
      <Founder />
    </div>
  );
};

export default AboutUS;